import PropTypes from 'prop-types';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { Loader } from 'semantic-ui-react';

import { useQuadreMedicData } from '../../helpers/quadreMedic';
import messages from './quadreMedicMessages';

const QuadreMedicEmbed = ({ language, especialitat }) => {
  const intl = useIntl();
  const { loading, quadreMedicList } = useQuadreMedicData(
    language,
    especialitat,
  );
  const [selectedIndex, setSelectedIndex] = useState(undefined);

  if (loading) {
    return (
      <div className="csj-page-loader">
        <Loader active inline="centered" />
      </div>
    );
  }

  if (!quadreMedicList.length) {
    return null;
  }

  const selected =
    selectedIndex !== undefined ? quadreMedicList[selectedIndex] : undefined;

  return (
    <div className="quadre-medic">
      <div className="quadre-medic-left">
        <h3 className="csj-heading3">{intl.formatMessage(messages.heading)}</h3>
        <span className="short-border" />
      </div>
      <div className="quadre-medic-center">
        <ul className="metges">
          {quadreMedicList.map((item) => (
            <li
              className={
                selectedIndex === item.index ? 'metge selected' : 'metge'
              }
              key={item.CognomsNom}
              onClick={() => setSelectedIndex(item.index)}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  setSelectedIndex(item.index);
                }
              }}
              role="button"
              tabIndex={0}
            >
              {item.CognomsNom}
            </li>
          ))}
        </ul>
      </div>
      <div className="quadre-medic-right">
        {selected ? (
          <>
            <span className="metge-nom">{selected.CognomsNom}</span>
            {selected.Lloc.length > 0 ? (
              <div className="metge-fila">
                <span className="metge-key">
                  {intl.formatMessage(
                    selected.Lloc.length > 1
                      ? messages.locationsLabel
                      : messages.locationLabel,
                  )}
                </span>
                {selected.Lloc.length > 1 ? (
                  <ul className="metge-value-list">
                    {selected.Lloc.map((item) => (
                      <li
                        className="metge-value metge-value-list-item"
                        key={item}
                      >
                        {item}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <span className="metge-value">{selected.Lloc[0]}</span>
                )}
              </div>
            ) : null}
            {selected.Unitat.length > 0 ? (
              <div className="metge-fila">
                <span className="metge-key">
                  {intl.formatMessage(
                    selected.Unitat.length > 1
                      ? messages.unitsLabel
                      : messages.unitLabel,
                  )}
                </span>
                {selected.Unitat.length > 1 ? (
                  <ul className="metge-value-list">
                    {selected.Unitat.map((item) => (
                      <li
                        className="metge-value metge-value-list-item"
                        key={item}
                      >
                        {item}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <span className="metge-value">{selected.Unitat[0]}</span>
                )}
              </div>
            ) : null}
            {selected.Cobertura.length > 0 ? (
              <div className="metge-fila">
                <span className="metge-key">
                  {intl.formatMessage(
                    selected.Cobertura.length > 1
                      ? messages.coveragesLabel
                      : messages.coverageLabel,
                  )}
                </span>
                {selected.Cobertura.length > 1 ? (
                  <ul className="metge-value-list">
                    {selected.Cobertura.map((item) => (
                      <li
                        className="metge-value metge-value-list-item"
                        key={item}
                      >
                        {item}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <span className="metge-value">{selected.Cobertura[0]}</span>
                )}
              </div>
            ) : null}
            {selected.Societat.length > 0 ? (
              <div className="metge-fila">
                <span className="metge-key">
                  {intl.formatMessage(messages.societyLabel)}
                </span>
                <span className="metge-value">
                  {selected.Societat.join(', ')}
                </span>
              </div>
            ) : null}
          </>
        ) : null}
      </div>
    </div>
  );
};

QuadreMedicEmbed.propTypes = {
  language: PropTypes.string.isRequired,
  especialitat: PropTypes.string,
};

export default QuadreMedicEmbed;
